import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const CardLayoutAlert = ({
  packagedQuantities,
  ownedQuantity,
  isHubSpotCredits,
  includedDefaultUnits,
  titleString
}) => {
  if (isHubSpotCredits) {
    if (ownedQuantity && includedDefaultUnits) {
      return /*#__PURE__*/_jsx(Alert, {
        type: "info",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.addOns.cards.alert.alertTitleOwnAndIncluded"
        }),
        marginBlockEnd: "1000",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.addOns.cards.alert.alertDescriptionOwnAndIncluded",
          options: {
            includedDefaultUnits,
            ownedQuantity: ownedQuantity * (packagedQuantities || 1)
          }
        })
      });
    } else if (includedDefaultUnits) {
      return /*#__PURE__*/_jsx(Alert, {
        type: "info",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.addOns.cards.alert.alertTitleIncluded",
          options: {
            includedDefaultUnits
          }
        }),
        marginBlockEnd: "1000"
      });
    }
  } else {
    if (ownedQuantity) {
      return /*#__PURE__*/_jsx(Alert, {
        type: "info",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricingPage.pages.addOns.cards.alert.alertTitleOwn",
          options: {
            ownedQuantity,
            title: titleString
          }
        }),
        marginBlockEnd: "1000"
      });
    }
  }
  return null;
};
export default CardLayoutAlert;